import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetQaAttemptError,
  GetQaAttemptVariables,
  fetchGetQaAttempt,
} from '../toolkitComponents.js';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schema>;
const { schema } = Registry.getQaAttempt;

export function useGetQaAttempt(
  variables: GetQaAttemptVariables,
  opts?: UseQueryOptions<Response, GetQaAttemptError>,
): UseQueryResult<Response> {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<Response, GetQaAttemptError>(
    queryKeyFn({
      path: '/api/v2/orders/{orderID}/qaAttempts',
      operationId: 'getQaAttempt',
      variables,
    }),
    async () => {
      const res = await fetchGetQaAttempt({ ...fetcherOptions, ...variables });
      return schema.parse(res);
    },
    opts,
  );
}
